import VisaoExecutivaGeralView from "../../components/gestaoOrcamentaria/VisaoExecutivaGeralView";
import { DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA } from "../../constants/departamentosOrcamento";

export default function VisaoExecutivaDespesas() {
  return <VisaoExecutivaGeralView tituloModulo="Visão Executiva Despesas" departamentos={DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA} />;
}
